import { defineComponent as _defineComponent } from 'vue'
import { watch, ref } from 'vue';
import SvgArrow from "@/assets/icons/arrow-down.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCollapse',
  props: {
    value: { type: Boolean }
  },
  emits: [
    'update:value',
],
  setup(__props: any, { emit: emits }) {

const props = __props as {
    value: boolean,
}





const collapse = ref(false);

const handleClickCollapseButton = (): void => {
    collapse.value = !collapse.value;
    emits('update:value', collapse.value);
};

watch(() => props.value, (val: boolean) => {
    collapse.value = val;
}, { immediate: true });

return { __sfc: true,props, emits, collapse, handleClickCollapseButton, SvgArrow }
}

})